import "./index.scss";
import { useEffect, useState } from "react";
import { useLocation } from "react-router";
import { DesktopNavbar, MobileNavbar } from "components/UI/organisms";
import { INTERNAL_PATHS } from "routes/paths";
import { useWindowDimensions } from "hooks/useWindowDimensions";
import {
  LEFT_SIDE_ITEMS as leftSideItems,
  RIGHT_SIDE_ITEMS as rightSideItems,
  MENU_ITEMS as menuItems,
  TRANSPARENT_NAVBAR_PAGES
} from "./utils/constants";

export const NavbarHeader = () => {
  const [pageOffset, setPageOffset] = useState(window.scrollY);
  const { pathname } = useLocation();
  const { width } = useWindowDimensions();
  const isDesktop = width >= 1200;

  const isHomePage = pathname === INTERNAL_PATHS.HOME;
  const isTopScreen = pageOffset === 0;
  const hasTransparentNavbar = TRANSPARENT_NAVBAR_PAGES.some((route) => {
    const trimmedRoute = route.replace(/\/:[^/]+/g, "");
    return pathname.includes(trimmedRoute);
  });

  useEffect(() => {
    const handleScroll = () => setPageOffset(window.scrollY);

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  });

  const navbarProps = {
    isHomePage,
    isTopScreen,
    hasTransparentNavbar,
    leftSideItems,
    rightSideItems,
    menuItems
  };

  return (
    <nav
      className={`navbar-header ${hasTransparentNavbar && "transparent"} ${
        isTopScreen && "top-screen"
      }`}
    >
      {isDesktop ? (
        <DesktopNavbar {...navbarProps} />
      ) : (
        <MobileNavbar {...navbarProps} />
      )}
    </nav>
  );
};
